<dx-popup
  [showTitle]="true"
  [title]="dialogTitle()"
  [visible]="displayDialog()"
  [width]="700"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()">

  <form novalidate>
    <div class="dialog-line">
      <div class="label" title="Site">Site <span class="danger-color">*</span></div>
      <div class="value">
        <yo-lookup
          [data]="findAllLocalSites()"
          [selectedItem]="formData().site?.id"
          autoSelect="false"
          [placeholder]="sitePlaceholder()"
          (onValueChange)="onChangeSite($event)"
          [disabled]="!canModify()">
        </yo-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Libellé">Libellé <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box class="inputfield" placeholder="Libellé"
                     [value]="formData().libelle"
                     (onValueChanged)="onChangeLibelle($event)"
                     [disabled]="!canModify()">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Taxe">Taxe <span class="danger-color">*</span></div>
      <div class="value">
        <dx-lookup
          [dataSource]="taxesSvc.taxeList.value() ?? []"
          [value]="formData().taxe?.id"
          valueExpr="id"
          [displayExpr]="customTaxeDisplayExpr"
          [searchEnabled]="true"
          [placeholder]="taxePlaceholder()"
          (onSelectionChanged)="onChangeTaxe($event)"
          [disabled]="!canModify()">
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Code">Code <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box class="inputfield" placeholder="Code"
                     [value]="formData().code"
                     (onValueChanged)="onChangeCode($event)"
                     [disabled]="!canModify()">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line actif-container">
      <div class="label" title="Type">Type <span class="danger-color">*</span></div>
      <div class="value">
        <dx-select-box
          [dataSource]="typesFraisFixe"
          valueExpr="value"
          displayExpr="label"
          [value]="formData().typeFraisFixe"
          placeholder="Sélectionner le type..."
          (onValueChanged)="onChangeTypeFraisFixe($event)"
          [disabled]="!canModify()">
        </dx-select-box>
      </div>
    </div>

    <div class="custom-button-container-right">
      <yo-button
        type="submit"
        iconClass="fas fa-save"
        tooltip="Enregistrer"
        [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!isFormValid()"
        (onClick)="save()"
        [hidden]="!canModify()">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()"
        tooltip="Fermer"
        iconClass="fas fa-times">
      </yo-button>
    </div>
  </form>

</dx-popup>
